import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopRazorpay = dynamic(() => import("../../components/payment-partners/razorpay/DesktopRazorpay"), {
    loading: () => <Loading />,
}
);

const MobileRazorpay = dynamic(() => import("../../components/payment-partners/razorpay/MobileRazorpay"), {
    loading: () => <Loading />,
}
);

const razorpayIntegration = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>Razor Sharp Transactions With QueueBuster POS</title>
                <meta name="description" content="Power your business with a seamless duo: Razorpay POS hardware & QueueBuster POS software." />
                <link rel="canonical" href="https://queuebuster.co/pos-payment-partners/razorpay" />
                <link rel="alternate" href="https://queuebuster.co/pos-payment-partners/razorpay" hrefLang="en-us" />
                <meta property="og:title" content="Razor Sharp Transactions With QueueBuster POS" />
                <meta property="og:description" content="Power your business with a seamless duo: Razorpay POS hardware & QueueBuster POS software." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/razorpay.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-payment-partners/razorpay" />
                
            </Head>
            {mobileView ? <MobileRazorpay /> : <DesktopRazorpay />}
        </>
    )
}

export default razorpayIntegration